<template>
  <form class="ovg-form" @submit.prevent="onSubmit">
    <div class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-servicio">Tipo de Servicio</label>
        <select
          id="input-servicio"
          v-model="formGarantia.tipo_servicio"
          class="ovg-select"
        >
          <option
            v-for="opt in serviceOptions"
            :key="String(opt.value)"
            :value="opt.value"
          >
            {{ opt.text }}
          </option>
        </select>
      </div>
    </div>

    <div v-show="formGarantia.tipo_servicio == 1" class="ovg-row">
      <div class="ovg-field ovg-field--320">
        <label class="ovg-label" for="input-fecha">Fecha de Compra</label>
        <b-form-datepicker
          id="input-fecha"
          v-model="formGarantia.fecha_de_compra"
          class="ovg-datepicker"
          placeholder="Selecciona"
          select-variant="primary"
        />
      </div>
    </div>

    <div class="ovg-row">
      <div class="ovg-field">
        <label class="ovg-label" for="input-falla"
          >Describe el problema de tu equipo</label
        >
        <textarea
          id="input-falla"
          v-model="formGarantia.reporte_falla_cliente"
          class="ovg-textarea"
          :class="{
            'ovg-textarea--error':
              $v.formGarantia.reporte_falla_cliente.$dirty &&
              $v.formGarantia.reporte_falla_cliente.$invalid,
          }"
          placeholder="Ej: El equipo no enciende al presionar el botón, la pantalla parpadea, la batería no carga, etc. Detalla lo más posible para ayudar a nuestros técnicos."
          @blur="$v.formGarantia.reporte_falla_cliente.$touch()"
        />
        <p
          v-if="
            $v.formGarantia.reporte_falla_cliente.$dirty &&
            !$v.formGarantia.reporte_falla_cliente.required
          "
          class="ovg-error"
        >
          Campo requerido
        </p>
      </div>
    </div>

    <div v-show="formGarantia.tipo_servicio == 1" class="ovg-upload">
      <label class="ovg-label">Comprobante de Compra (Boleta o Factura)*</label>
      <UploadFilePreIngreso :setBoleta="setBoleta" :boleta="boleta" />
    </div>

    <div class="ovg-card__footer ovg-card__footer--between">
      <button type="button" class="ovg-btn ovg-btn--secondary" @click="goBack">
        Paso Anterior
      </button>
      <button type="submit" class="ovg-btn ovg-btn--primary">
        Siguiente Paso
      </button>
    </div>
  </form>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators'
import UploadFilePreIngreso from './UploadFilePreIngreso.vue'

export default {
  props: ['setDatosGarantia', 'guardarBoleta', 'garantiaReturn', 'boleta'],
  components: {
    UploadFilePreIngreso,
  },
  data() {
    return {
      formGarantia: {
        tipo_servicio: this.garantiaReturn.tipo_servicio
          ? this.garantiaReturn.tipo_servicio
          : null,
        reporte_falla_cliente: this.garantiaReturn.reporte_falla_cliente
          ? this.garantiaReturn.reporte_falla_cliente
          : '',
        fecha_de_compra: this.garantiaReturn.fecha_de_compra
          ? this.garantiaReturn.fecha_de_compra
          : null,
      },
      boletaLocal: this.boleta || '',
      serviceOptions: [
        { value: null, text: 'Selecciona' },
        { value: 1, text: 'Garantía' },
        { value: 4, text: 'Presupuesto' },
      ],
    }
  },
  validations: {
    formGarantia: {
      reporte_falla_cliente: {
        required: requiredIf(function f() {
          return this.formGarantia.tipo_servicio === 4
        }),
      },
    },
  },
  watch: {
    garantiaReturn: {
      handler() {
        this.formGarantia = {
          tipo_servicio: this.garantiaReturn.tipo_servicio
            ? this.garantiaReturn.tipo_servicio
            : null,
          reporte_falla_cliente: this.garantiaReturn.reporte_falla_cliente
            ? this.garantiaReturn.reporte_falla_cliente
            : '',
          fecha_de_compra: this.garantiaReturn.fecha_de_compra
            ? this.garantiaReturn.fecha_de_compra
            : null,
        }
      },
      deep: true,
    },
    boleta(val) {
      this.boletaLocal = val || ''
    },
  },
  methods: {
    async onSubmit() {
      if (this.$v.$invalid) {
        this.$bvToast.toast('Rellene todos los campos requeridos', {
          variant: 'danger',
        })
        this.$v.$touch()
      } else {
        this.setDatosGarantia(this.formGarantia)
        this.guardarBoleta(this.boletaLocal)
        this.$bvToast.toast('Datos guardado exitosamente', {
          variant: 'success',
        })
      }
    },
    setBoleta(boleta) {
      this.boletaLocal = boleta
    },
    goBack() {
      this.$emit('goBack')
    },
  },
}
</script>
